// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "DiagonalLine-module--arrow-up-and-down--160b9";
export var line = "DiagonalLine-module--line--b3211";
export var lineContainer = "DiagonalLine-module--lineContainer--64894";